import { render, staticRenderFns } from "./GeographicalDistributionTable.vue?vue&type=template&id=6badf56a&"
import script from "./GeographicalDistributionTable.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports